import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, {
    ref: "sw",
    height: _ctx.height
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {
        height: _ctx.height,
        element: _ctx.scrollbarEl
      })
    ]),
    _: 3
  }, 8, ["height"]))
}